import React, { Suspense } from 'react';
import { Helmet } from 'react-helmet-async';

const GenieclassRecordedLesson = React.lazy(
  () => import('genieclass/GenieclassRecordedLesson'),
);

export default function GenieclassRecordedLessonPage() {
  return (
    <div className="genieclass-recorded-lesson-container h-[calc(100vh-68px)] max-lg:h-[calc(100vh-110px)] max-md:h-[calc(100vh-100px)]">
      <Helmet>
        <title>Geniebook - Genieclass Recorded Lesson</title>
        <meta name="description" content="Genieclass Recorded Lesson" />
      </Helmet>
      <Suspense>
        <GenieclassRecordedLesson />
      </Suspense>
    </div>
  );
}
